import { Module } from 'vuex';
import merge from 'lodash/fp/merge';

import { IRootState, client } from '@/store';
import { IPageParams, ICRUDResponse } from '@/models';

interface IState<IEntity> {
  entities: Record<string, IEntity>;
  currentPage: Array<number | string>;
  pageParams: Partial<IPageParams>;
  loading: boolean;
}

export function createModule<IEntity extends { id: string | number }>(
  ns: string,
  options?: Partial<Module<IState<IEntity>, IRootState>> & { url?: string },
) {
  const route = options?.url || ns;
  const module: Module<IState<IEntity>, IRootState> = {
    namespaced: true,
    state: {
      entities: {},
      currentPage: [],
      pageParams: {
        per_page: 10,
        current_page: 1
      },
      loading: true
    },
    actions: {
      /*getEntities({ commit, state: { pageParams } }, { page }: { page?: number } = {}) {
        commit('setLoading', true);
        client
          .get<ICRUDResponse<IEntity[]>>(route, { params: { ...pageParams } })
          .then(({ data: { data, ...pageParams } }) => {
            commit('setEntities', data);
            commit('setPageParams', pageParams);
            commit('setLoading', false);
            return data;
          });
      },*/
      getEntities({ commit, rootState }) {
        commit('setLoading', true)
        const params: Record<string, string> = {};
        if (rootState.tableFilters?.params?.hasOwnProperty(ns)) {
          // @ts-ignore
          for (const [key, value] of Object.entries(rootState.tableFilters.params[ns])) {
            // @ts-ignore
            if (value && value.length) {
              // @ts-ignore
              params[key] = Array.isArray(value) ? value.join(',') : value
            }
          }
        }
        // @ts-ignore
        const sort = rootState.tableFilters.options[ns].sortBy?.map((item, index) => {
          // @ts-ignore
          return [item, rootState.tableFilters.options[ns].sortDesc[index] ? 'desc' : 'asc']
        })
        client
          // @ts-ignore
          .get<ICRUDResponse<IEntity[]>>(route, { params: { ...params, per_page: rootState.tableFilters.options[ns].itemsPerPage, page: rootState.tableFilters.options[ns].page, sort } })
          .then(({ data: { data, ...pageParams } }) => {
            commit('setEntities', data);
            commit('setPageParams', pageParams);
            commit('setLoading', false)
          });
      },
      async getEntity({ commit }, id) {
        const { data } = await client
          .get<ICRUDResponse<IEntity>>(`${route}/${id}`)
        return data
      },
      createEntity({ commit, dispatch }, entity: Omit<IEntity, 'id'>) {
        commit('setLoading', true);
        return client.post(route, entity).then(({ data }) => {
          // @ts-ignore
          dispatch('getEntity', data.id);
          commit('setLoading', false);
          return data;
        });
      },
      deleteEntity({ commit, dispatch }, entity: IEntity) {
        commit('setLoading', true);
        return client.delete(`${route}/${entity.id}`).then(() => {
          dispatch('getEntities');
          commit('setLoading', false);
          return;
        });
      },
      deleteEntities({ commit, dispatch }, entities: IEntity[]) {
        commit('setLoading', true);
        const arr = entities.flatMap(({ id }) => id);

        return client.post(`destroy/${route}`, arr).then(() => {
          dispatch('getEntities');
          commit('setLoading', false);
          return;
        });
      },
      async updateEntity({ dispatch }, entity: IEntity) {
        const { data } = await client
          .put(`${route}/${entity.id}`, entity)
        return data
      },
    },
    mutations: {
      setLoading(state, loading: boolean) {
        state.loading = loading;
      },
      setEntities(state, entities: IEntity[]) {
        state.entities = entities.reduce(
          (acc, item) => ({ ...acc, [item.id]: item }),
          {},
        );
        state.currentPage = entities.map((entity) => entity.id);
      },
      setPageParams(state, pageParams: IPageParams) {
        state.pageParams = pageParams;
      },
    },
    getters: {
      entitiesSlice({ currentPage, entities }) {
        return currentPage.map((id) => entities[id]);
      },
    },
  };
  return merge(module)(options);
}
